import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class FormService {
    private _submitted: string;
    public submitted$: EventEmitter<string>;

    constructor() {
        this.submitted$ = new EventEmitter<string>();
    }

    /**
     * AngularJS Connector used to pass down the submitted
     * state so that Angular forms can run validation checks.
     * @param submitted
     */
    public submit(submitted: string): void {
        this._submitted = submitted;
        this.submitted$.emit(this._submitted);
    }

}
